/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectProfilePermissionsSelector } from '../../store/api/auth/selectors';
import ProfilePermissions from '../../utils/ProfilePermissions';

const RequireAdmin: React.FC<{ children: ReactNode }> = ({ children }) => {
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);
   
  return (
    permissions?.hasAdminPermissions()
      ? children
      : null
  );
};

export default RequireAdmin;